import { useCallback } from 'react';

import { link, routes } from '@aline/routes';
import { useMatch, useNavigate } from 'react-router-dom';
import { startNewChatDraft } from 'src/components/ai/chat/chat-state/chat-state-actions';
import { aiThreadIdVar } from 'src/editor/toolbars/right-panel/ai';
import { useGlobalDrawer } from 'src/layouts/GlobalRightDrawer';

const CREATE_SKILL_PROMPT =
  'Create a new skill **[describe the task, when Aline should use it, and attach example files here]**.';

/**
 * Opens a new chat with a draft that asks the agent to create a skill. Shared by the skills
 * list's "+" and the chat "/" picker, so both start the same conversation.
 */
export function useCreateSkillWithAi() {
  const { openDrawer } = useGlobalDrawer();
  const navigate = useNavigate();
  const chatMatch = useMatch({ end: false, path: routes.ChatIndex });
  const workflowThreadMatch = useMatch(routes.WorkflowDetailTabThread);
  const taskThreadMatch = useMatch(routes.WorkflowDetailTabTaskThread);

  const createSkillWithAi = useCallback(() => {
    startNewChatDraft(CREATE_SKILL_PROMPT);
    aiThreadIdVar(null);
    if (chatMatch) {
      navigate(link.ChatIndex());
      return;
    }

    const { taskId, workflowId } = taskThreadMatch?.params ?? {};
    if (taskId && workflowId) navigate(link.WorkflowDetailTabTask({ taskId, workflowId }));
    else if (workflowThreadMatch?.params.workflowId)
      navigate(
        link.WorkflowDetailTabComments({ workflowId: workflowThreadMatch.params.workflowId })
      );
    openDrawer();
  }, [chatMatch, navigate, openDrawer, taskThreadMatch, workflowThreadMatch]);

  return { createSkillWithAi };
}
